import * as S from "./EventExercise.style";
import { Video } from "@/common/types/video";
import { request } from "@/common/api";
import { Loading } from "@/components/atoms/Loading";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { exerciseStart } from "@/common/functions/flutter";
import { useRecoilValue } from "recoil";
import { studentUserState } from "@/common/states/user";
import { GET_VIDEOS_BY_CATEGORY } from "@/common/querykeys";
import { ReactComponent as IconTime } from "@/styles/assets/svg/icon_time.svg";
import { ReactComponent as IconPlay } from "@/styles/assets/svg/icon_play_arrow.svg";

interface EventExerciseProps {
  exerciseCount: number;
  exercisePointEligibility: any;
}

const fetchVideosByCategory = async (category: string): Promise<Video[]> => {
  return await request<Video[]>({
    method: "GET",
    url: `/video-content/category/${category}`,
  });
};

export const EventExercise = ({
  exerciseCount,
  exercisePointEligibility,
}: EventExerciseProps) => {
  const navigate = useNavigate();
  const [exerciseModalShow, setExerciseModalShow] = useState(false);
  const student = useRecoilValue(studentUserState);

  const { data: videos, isPending } = useQuery({
    queryKey: [GET_VIDEOS_BY_CATEGORY],
    queryFn: () => fetchVideosByCategory("EVENT"),
    initialData: [],
    select: (data) => {
      return data;
    },
  });

  const formatDuration = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes === 0) {
      return `${remainingSeconds}초`;
    }

    return remainingSeconds > 0
      ? `${minutes}분 ${remainingSeconds}초`
      : `${minutes}분`;
  };

  const handleExerciseConfirm = (result: boolean) => {
    if (result) {
      exerciseStart(student?.id, videos[2]?.id, true);
    } else {
    }
  };

  return (
    <>
      {isPending ? (
        <Loading />
      ) : (
        <S.EventExerciseBox>
          <S.EventExerciseTit>운동 프로그램 체험해보기</S.EventExerciseTit>
          <S.VideoListRow>
            {[0, 1, 2].map((idx) => (
              <S.VideoItem
                key={idx}
                onClick={() =>
                  exerciseStart(student?.id, videos[idx]?.id, true)
                }
              >
                <S.VideoBox>
                  <S.EventExerciseInfoTxt>
                    {videos[idx] ? (
                      videos[idx].title
                        .replace(/^\[이벤트\]\s*/, "")
                        .replace(/\s*운동/g, "")
                    ) : (
                      <span>오늘의 운동이 없습니다.</span>
                    )}
                    {videos[idx] && (
                      <S.InfoTime>
                        총{formatDuration(Number(videos[idx].duration))}
                      </S.InfoTime>
                    )}
                  </S.EventExerciseInfoTxt>
                  <S.PlayBtn>
                    {videos[idx] && <IconPlay width={16} height={16} />}
                  </S.PlayBtn>
                </S.VideoBox>
              </S.VideoItem>
            ))}
          </S.VideoListRow>
        </S.EventExerciseBox>
      )}
      {/* {exerciseModalShow &&
        (exercisePointEligibility &&
        exercisePointEligibility?.points === 50000 &&
        exerciseCount === 36 ? (
          <ModalExerciseConfirm
            setModalShow={setExerciseModalShow}
            onConfirm={handleExerciseConfirm}
            type="all"
          />
        ) : exercisePointEligibility?.points === 50000 ? (
          <ModalExerciseConfirm
            setModalShow={setExerciseModalShow}
            onConfirm={handleExerciseConfirm}
            type="point"
          />
        ) : (
          <ModalExerciseConfirm
            setModalShow={setExerciseModalShow}
            onConfirm={handleExerciseConfirm}
            type="exercise"
          />
        ))} */}
    </>
  );
};
